module.exports = __webpack_public_path__ + "files/8cc2e2c81658bf98cc0fb1e615ed9d42.png";